<template>
  <div class="ui inverted vertical footer segment form-page">
    <div class="ui container">
      Developer Melhem Jamal Modjebovich 
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>